import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DocumentReference, DocumentService } from 'src/app/documents/documents.service';
import { HelloGuide, VesselsService } from '../vessels.service';
import { saveAs } from 'file-saver';
import { MessageLevel, PgMessagesService } from 'src/app/shared/services/pg-messages.service';
import { ActionType, DataBaseActionService } from 'src/app/shared/services/database-action.service';
import { KeycloakService } from 'src/app/authentication/keycloak.service';
import { SharedModule } from 'src/app/shared/shared.module';
import { MaterialChunkFileUploadComponent } from 'src/app/shared/components/material-file-uploader/material-chunk-file-upload.component';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MaterialAutoCompleteComponent } from 'src/app/shared/components/material-autocomplete/material-auto-complete.component';

@Component({
  selector: 'app-hello-help',
  templateUrl: './hello-help.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    SharedModule,
    MaterialChunkFileUploadComponent,
    MatSelectModule,
    MatButtonModule,
    MaterialAutoCompleteComponent

  ]
})

export class HelloHelpComponent implements OnInit {
  helloGuide!: HelloGuide;
  uploadedFiles: HelloGuide[] = [];
  pendingFile: HelloGuide[] = [];
  accept: string = '';
  doc?: DocumentReference;

  documentTypes: string[] = ['help', 'instruction', 'guide'];

  constructor(
    private _vesselsService: VesselsService,
    private _documentsService: DocumentService,
    private _pgMessagesService: PgMessagesService,
    private _actionService: DataBaseActionService,
    private _keycloakService: KeycloakService,
  ) { }

  ngOnInit(): void {
    this.helloGuide = {
      fileName: '',
      fileId: '',
      documentType: '',
      fileType: '',
      actions: [],
    };
    this._vesselsService.getAllHelloHelp().subscribe(helps => {
      this.uploadedFiles = helps
        .sort((a, b) => (b.actions?.find(a => a.userAction === ActionType.Create)!.timestamp) - (a.actions?.find(a => a.userAction === ActionType.Create)!.timestamp));
    });
  }

  hasRole(role: string) {
    return this._keycloakService.hasRole(role);
  }

  getFileId(file: DocumentReference) {
    this.helloGuide.fileId = file.id;
    this.helloGuide.fileName = file.fileName;
    this.helloGuide.fileType = file.fileType!;
  }

  typesAccept(type: string): void {
    if (type === 'guide') {
      this.accept = '.mp4';
    } else if (type === 'help' || type === 'instruction') {
      this.accept = '.pdf,.jpg';
    } else {
      this.accept = '';
    }
  }

  uploadDate(helloGuide: HelloGuide): number {
    return helloGuide.actions?.find(a => a.userAction === ActionType.Create)!.timestamp;
  }

  save(): void {
    if (!this.helloGuide.fileId || !this.helloGuide.documentType) {return;}
    this.helloGuide.actions.push(this._actionService.userAction(ActionType.Create));
    this._vesselsService.upsertHelloGuide(this.helloGuide).subscribe(() => {
      this._vesselsService.getAllHelloHelp().subscribe(helps => this.uploadedFiles = helps);
      this._pgMessagesService.publishMessage({
        message: 'File saved successfully.',
        level: MessageLevel.Info,
        topic: 'Help File',
      });
    });
  }

  downloadFile(fileId: string): void {
    this._documentsService.download(fileId).subscribe(
      (response) => {
        const fileName = this.uploadedFiles.find(file => file.fileId === fileId)?.fileName;
        if (fileName) {
          saveAs(response.body, fileName);
        }
      },
      () => {
        this._pgMessagesService.publishMessage({
          message: 'Could not download this file.',
          level: MessageLevel.Error,
          topic: 'Help File',
        });
      }
    );
  }

  removeFile(file: HelloGuide): void {
    if (confirm('Are you sure you want to delete this file?')) {
      file.isDeleted = true;
      file.actions.push(this._actionService.userAction(ActionType.Delete));

      this._vesselsService.upsertHelloGuide(file).subscribe(() => {
        this.uploadedFiles = this.uploadedFiles.filter(f => f.fileId !== file.fileId);
        this._pgMessagesService.publishMessage({
          message: 'File deleted successfully.',
          topic: 'Help File',
          level: MessageLevel.Info
        });
      });
    }
  }

  documentTypeFormatter(documentType: string): string {
    if (documentType === 'guide') {
      return 'Guide';
    } else if (documentType === 'help') {
      return 'Help';
    } else if (documentType === 'instruction') {
      return 'Instruction';
    }

    return documentType ?? '';
  }
}
